import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  private addMessage(
    severity: string,
    summary: string,
    detail: string,
    duration: number = 2000
  ) {
    this.messageService.add({
      severity: severity,
      summary: summary,
      detail: detail,
      life: duration,
      sticky: false,
    });
  }

  success(summary: string, detail: string="", duration: number = 2000) {
    this.addMessage('success', summary, detail, duration);
  }

  info(summary: string, detail: string="", duration: number = 2000) {
    this.addMessage('info', summary, detail, duration);
  }

  warning(summary: string, detail: string="", duration: number = 2000) {
    this.addMessage('warn', summary, detail, duration);
  }

  error(summary: string, detail: string="", duration: number = 2000) {
    this.addMessage('error', summary, detail, duration);
  }
}
